import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import CreateFolder from './CreateFolder';
import UploadFile from './UploadFile';


function NewButton({ fetchFolderContents,setUploadPopups }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleNewButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="new-button">
      <Button
        style={{ backgroundColor: 'orange', color: 'white', textTransform: 'none' }}
        aria-controls="new-menu"
        aria-haspopup="true"
        onClick={handleNewButtonClick}
      >
        New
      </Button>
      <Menu id="new-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <CreateFolder fetchFolderContents={fetchFolderContents} handleClose={handleClose} anchorEl={anchorEl} />
        <UploadFile fetchFolderContents={fetchFolderContents} handleClose={handleClose} setUploadPopups={setUploadPopups}/>
      </Menu>
    </div>
  );
}

export default NewButton;
